import React, { useEffect, useState } from "react";
import { DataTable, Tag, Icon } from 'pepsico-ds';
import { Col, Row } from 'antd';
import SingleSelectDropdown from '../Dropdown/SingleSelectDropdown'
import { sortData } from '../../utils/utils';
// import * as XLSX from 'xlsx';
import { exportRowsToExcel } from '../../utils/excelExport';
import { saveAs } from 'file-saver';
import download_logo from '../../assets/download_logo.png'

function SupplierPerfTable({ data }) {
	const sortColumns = [
		{ id: 1, value: "vendorName", displayText: "Supplier Name" },
		{ id: 2, value: "spend", displayText: "Spend ($ MN)" },
		{ id: 3, value: "otif", displayText: "OTIF" },
		{ id: 4, value: "otd", displayText: "OTD" }, ,
		{ id: 5, value: "fillRate", displayText: "Fill Rate" },
	];

	const sortOrderList = [
		{ id: 1, value: "asc", displayText: "Ascending" },
		{ id: 2, value: "desc", displayText: "Descending" }
	];
	/* istanbul ignore next */
	let columns = [
		{ columnKey: 'vendorName', header: "Supplier Name", initialSize: 483, minSize: 20, maxSize: 20 },
		{ columnKey: 'spend', header: () => <>Spend ($ MN) {sortColumn == "spend" && <Icon alt="" icon={sortOrder == "asc" ? "arrow_upward" : "arrow_downward"} size="small" />} </>, initialSize: 90, minSize: 360, maxSize: 360 },
		{ columnKey: 'otif', header: () => <>OTIF {sortColumn == "otif" && <Icon alt="" icon={sortOrder == "asc" ? "arrow_upward" : "arrow_downward"} size="small" />} </>, initialSize: 90, minSize: 360, maxSize: 360 },
		{ columnKey: 'otd', header: () => <>OTD {sortColumn == "otd" && <Icon alt="" icon={sortOrder == "asc" ? "arrow_upward" : "arrow_downward"} size="small" />} </>, initialSize: 90, minSize: 360, maxSize: 360 },
		{ columnKey: 'fillRate', header: () => <>Fill Rate {sortColumn == "fillRate" && <Icon alt="" icon={sortOrder == "asc" ? "arrow_upward" : "arrow_downward"} size="small" />} </>, initialSize: 90, minSize: 360, maxSize: 360 },
	];

	const [sortColumn, setSortColumn] = useState([])
	const [sortOrder, setSortOrder] = useState([])
	const [finalData, setFinalData] = useState([])
	const [finalColumns, setFinalColumns] = useState([])


	useEffect(() => {
		if (data) {
			setSortColumn([sortColumns[0]])
			setSortOrder([sortOrderList[0]])
			setFinalData(data)
			setFinalColumns(columns)
		}
	}, [data])

	useEffect(() => {
		reOrderData()
	}, [sortColumn, sortOrder])
	/* istanbul ignore next */
	const onColumnSelChange = (val) => {
		if (val && val.length > 0) {
			setSortColumn(val);
		}
	}

	
	const onSortOrderChange = (val) => {
		if (val && val.length > 0) {
			setSortOrder(val);
		}
	}

	/* istanbul ignore next */
	const reOrderData = () => {
		if (sortColumn && sortOrder) {
			const selectedSortColumn = sortColumn?.[0]?.value
			const selectedSortOrder = sortOrder?.[0]?.value
			const sortedData = sortData(data, selectedSortColumn, selectedSortOrder)
			setFinalData(sortedData)
			const abc = selectedSortColumn + selectedSortOrder
			let updatedColumns = [
				{ id: 0, columnKey: 'vendorName', header: abc, initialSize: 0, minSize: 0, maxSize: 0 },
				{
					id: 1, columnKey: 'vendorName', header: () => <span className={selectedSortColumn === "vendorName" ? 'selected-sup-perf-header' : ''} style={{ display: "flex", fontSize: 15 }}>Supplier Name {selectedSortColumn === "vendorName" && <Icon alt="" icon={selectedSortOrder === "asc" ? "arrow_upward" : "arrow_downward"} size="small" />} </span>,
					cellData: (ctx) => {
						const vendorName = ctx.row.original.vendorName;
						return <span className={selectedSortColumn === "vendorName" ? 'selected-sup-perf-header' : ''} style={{ display: "flex" }}>{vendorName}</span>
					}, initialSize: 483, minSize: 20, maxSize: 20
				},
				{
					id: 2, columnKey: 'spend', header: () => <span className={selectedSortColumn === "spend" ? 'selected-sup-perf-header' : ''} style={{ display: "flex", fontSize: 15 }}>Spend ($ MN) {selectedSortColumn === "spend" && <Icon alt="" icon={selectedSortOrder === "asc" ? "arrow_upward" : "arrow_downward"} size="small" />} </span>,
					cellData: (ctx) => {
						const spend = ctx.row.original.spend;
						return <span className={selectedSortColumn === "spend" ? 'selected-sup-perf-header' : ''} style={{ display: "flex" }}>{spend}</span>
					}, initialSize: 90, minSize: 360, maxSize: 360
				},
				{
					id: 3, columnKey: 'otif', header: () => <span className={selectedSortColumn === "otif" ? 'selected-sup-perf-header' : ''} style={{ display: "flex", fontSize: 15 }}>OTIF {selectedSortColumn === "otif" && <Icon alt="" icon={selectedSortOrder === "asc" ? "arrow_upward" : "arrow_downward"} size="small" />} </span>,
					cellData: (ctx) => {
						const otif = ctx.row.original.otif;
						return <span className={selectedSortColumn === "otif" ? 'selected-sup-perf-header' : ''} style={{ display: "flex" }}>{otif.toFixed(1)}</span>
					}, initialSize: 90, minSize: 360, maxSize: 360
				},
				{
					id: 5, columnKey: 'fillRate', header: () => <span className={selectedSortColumn === "fillRate" ? 'selected-sup-perf-header' : ''} style={{ display: "flex", fontSize: 15 }}>Fill Rate {selectedSortColumn === "fillRate" && <Icon alt="" icon={selectedSortOrder === "asc" ? "arrow_upward" : "arrow_downward"} size="small" />} </span>,
					cellData: (ctx) => {
						const fillRate = ctx.row.original.fillRate;
						return <span className={selectedSortColumn === "fillRate" ? 'selected-sup-perf-header' : ''} style={{ display: "flex" }}>{fillRate.toFixed(1)}</span>
					}, initialSize: 90, minSize: 360, maxSize: 360
				},
				{
					id: 4, columnKey: 'otd', header: () => <span className={selectedSortColumn === "otd" ? 'selected-sup-perf-header' : ''} style={{ display: "flex", fontSize: 15 }}>OTD {selectedSortColumn === "otd" && <Icon alt="" icon={selectedSortOrder === "asc" ? "arrow_upward" : "arrow_downward"} size="small" />} </span>,
					cellData: (ctx) => {
						const otd = ctx.row.original.otd;
						return <span className={selectedSortColumn === "otd" ? 'selected-sup-perf-header' : ''} style={{ display: "flex" }}>{otd.toFixed(1)}</span>
					}, initialSize: 90, minSize: 360, maxSize: 360
				},
				{ id: 6, columnKey: 'vendorName', header: abc, initialSize: 0, minSize: 0, maxSize: 0 },
			];

			setFinalColumns([...updatedColumns]);
		}
	}

	// const downloadExcel = () => {
	// 	const columnsToInclude = [
	// 	  "SUPPLIER NAME",
	// 	  "SPEND ($ MN)",
	// 	  "OTIF",
	// 	  "FILL RATE",
	// 	  "OTD"
	// 	];
	  
	// 	const columnMapping = {
	// 	  vendorName: "SUPPLIER NAME",
	// 	  spend: "SPEND ($ MN)",
	// 	  otif: "OTIF",
	// 	  fillRate: "FILL RATE",
	// 	  otd: "OTD"
	// 	};
	  
	// 	const transformedData = finalData.map(item => {
	// 	  const newItem = {};
	// 	  columnsToInclude.forEach(col => {
	// 		const originalKey = Object.keys(columnMapping).find(
	// 		  key => columnMapping[key] === col
	// 		);
	// 		newItem[col] = item[originalKey];
	// 	  });
	// 	  return newItem;
	// 	});
	  
	// 	// Create worksheet
	// 	const wsSupplierPerfTable = XLSX.utils.json_to_sheet(transformedData);
	  
	// 	// Bold the header row
	// 	for (let C = 0; C < columnsToInclude.length; ++C) {
	// 	  const cellAddress = XLSX.utils.encode_cell({ r: 0, c: C });
	// 	  if (wsSupplierPerfTable[cellAddress]) {
	// 		if (!wsSupplierPerfTable[cellAddress].s) wsSupplierPerfTable[cellAddress].s = {};
	// 		wsSupplierPerfTable[cellAddress].s.font = { bold: true };
	// 	  }
	// 	}
	  
	// 	// Optional: Adjust column width (customize widths if needed)
	// 	wsSupplierPerfTable['!cols'] = columnsToInclude.map(() => ({ wch: 20 }));
	  
	// 	// Create workbook and append sheet
	// 	const wbSupplierPerfTable = XLSX.utils.book_new();
	// 	XLSX.utils.book_append_sheet(wbSupplierPerfTable, wsSupplierPerfTable, 'Sheet1');
	  
	// 	// Write with styles enabled
	// 	const wbout = XLSX.write(wbSupplierPerfTable, {
	// 	  bookType: 'xlsx',
	// 	  type: 'array',
	// 	  cellStyles: true
	// 	});
	  
	// 	// Save the file
	// 	const blob = new Blob([wbout], { type: 'application/octet-stream' });
	// 	saveAs(blob, 'PERFORMANCE KPIS - SORTING TABLE.xlsx');
	//   };

	  /* istanbul ignore next */
	  const downloadExcel = async () => {
		const columnsToInclude = [
			"SUPPLIER NAME",
			"SPEND ($ MN)",
			"OTIF",
			"FILL RATE",
			"OTD"
		];
	
		const columnMapping = {
			vendorName: "SUPPLIER NAME",
			spend: "SPEND ($ MN)",
			otif: "OTIF",
			fillRate: "FILL RATE",
			otd: "OTD"
		};
	
		const transformedData = finalData.map(item => {
			const newItem = {};
			columnsToInclude.forEach(col => {
				const originalKey = Object.keys(columnMapping).find(
					key => columnMapping[key] === col
				);
				newItem[col] = item[originalKey];
			});
			return newItem;
		});
	
		await exportRowsToExcel({
			rows: transformedData,
			headers: columnsToInclude,
			fileName: 'PERFORMANCE KPIS - SORTING TABLE.xlsx',
			columnWidths: columnsToInclude.map(() => 20),
		});
	};
	  

	return (
		<>
			<div style={{ padding: "1rem", background: "rgb(239, 245, 252)", boxShadow: "0 0 24px #005cbc14" }} className="supplier-perf-table common-table">
				<Row gutter={[10, 10]} justify="start" style={{ width: "100%", marginBottom: "10px" }}>
					<Col xs={24} sm={24} md={3} lg={3} xl={3}>
						<SingleSelectDropdown className='buy-con-dropdown-modal' label="Select Column" childList={sortColumns} selectedValue={sortColumn} setSelectedValue={onColumnSelChange} />
					</Col>
					<Col xs={24} sm={24} md={3} lg={3} xl={3}>
						<SingleSelectDropdown className='buy-con-dropdown-modal' label="Sort Order" childList={sortOrderList} selectedValue={sortOrder} setSelectedValue={onSortOrderChange} />
					</Col>
				</Row>
				{
					finalColumns && finalColumns.length>0 && finalData && finalData.length>0 &&
					<>
						<button type="primary" onClick={downloadExcel} className="download-excel">
							<img src={download_logo} alt="download_logo" style={{position: 'relative', top: '2px'}}/>
							{/* <span style={{marginLeft: '8px', fontWeight: 'bold'}}>Download Data</span> */}
						</button>
						<DataTable
						key={JSON.stringify(finalColumns)}
						columns={finalColumns}
						data={finalData}
						// filters={filters}
						isDark={false}
						isExpandable={false}
						enableSorting={false}
						pageIndex={0}
						pageSize={10}
						selection="single"
						size="large"
						tableDescription=""
						tableHeader="Performance KPIs - Sorting Table"
						showColumnFilters={false}
					/>
					</>
				}

			</div>
		</>
	)
}


export default SupplierPerfTable;